import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_SHOW_OUTLET_MODAL,
  ONLINE_STORE_CLOSE_OUTLET_MODAL,
  ONLINE_STORE_START_SELECT_OUTLET_FLOW,
  ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL,
  ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL,
  ONLINE_STORE_SELECT_OUTLET,
  ONLINE_STORE_SELECT_OUTLET_INFO,
  ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
  ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL,
} from 'actions/onlineStore/constants';

const showOutletModal = createReducer(false, {
  [ONLINE_STORE_SHOW_OUTLET_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_OUTLET_MODAL]: () => false,
});

const source = createReducer(null, {
  [ONLINE_STORE_START_SELECT_OUTLET_FLOW]: (draft, { payload }) =>
    payload.source,
});

const channel = createReducer(null, {
  [ONLINE_STORE_START_SELECT_OUTLET_FLOW]: (draft, { payload }) =>
    payload.channel,
});

const outletName = createReducer(null, {
  [ONLINE_STORE_SELECT_OUTLET]: (draft, { payload }) => payload.outletName,
});

const outletInfo = createReducer(null, {
  [ONLINE_STORE_SELECT_OUTLET_INFO]: (draft, { payload }) => payload.outletInfo,
});

const showGoStoreNotActivatedModal = createReducer(false, {
  [ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL]: () => false,
});

const showGoStoreNotNationWideShippingModal = createReducer(false, {
  [ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL]: () => false,
});

export default combineReducers({
  showOutletModal,
  source,
  channel,
  outletName,
  outletInfo,
  showGoStoreNotActivatedModal,
  showGoStoreNotNationWideShippingModal,
});
